// 步骤翻译的共享配置
// 基于 Polymarket 前台展示方案 V2 重构
// 原则：默认层只讲结果，不讲机制；agent 作为能力标签，不作为标题主语

export const STEP_TRANSLATIONS = {
  // 能力标签（原 Agent，现仅作为辅助标签展示）
  // 不再展示"智能体/专家/顾问"等后台词
  capabilityTags: {
    'market-topic-explainer': {
      zh: '主题解读',
      en: 'Topic analysis'
    },
    'news-analyst': {
      zh: '新闻解读',
      en: 'News analysis'
    },
    'finance-expert': {
      zh: '市场解读',
      en: 'Market analysis'
    },
    'general-researcher': {
      zh: '综合分析',
      en: 'General analysis'
    },
    'beginner-guide': {
      zh: '新手帮助',
      en: 'Beginner help'
    },
    'trading-advisor': {
      zh: '交易分析',
      en: 'Trade analysis'
    },
    'platform-mechanics-expert': {
      zh: '平台规则',
      en: 'Platform rules'
    },
    'event-explainer': {
      zh: '事件解读',
      en: 'Event analysis'
    },
    'market-finder': {
      zh: '市场查询',
      en: 'Market finder'
    },
    'hot-news-digest': {
      zh: '热点新闻查询',
      en: 'Hot news digest'
    },
    'market-specialist': {
      zh: '市场专家',
      en: 'Market-specialist'
    },
    'price-change-expert': {
      zh: '价格变动专家',
      en: 'Price change expert'
    },
    'crypto-technical-analyst': {
      zh: '加密货币分析',
      en: 'Crypto technical analyst'
    },
    'portfolio-report-analyst': {
      zh: '投资分析师',
      en: 'Portfolio-report-analyst'
    },
    'portfolio-suggestion-narrator': {
      zh: '投资建议',
      en: 'Portfolio-suggestion-narrator'
    },
    'short-cycle-market-specialist': {
      zh: '短期市场专家',
      en: 'Short-cycle-market-specialist'
    },
  },

  // 主状态（默认展示，用户结果导向语言）
  // 多个后台 task 折叠到同一个用户可理解的主状态
  primaryStates: {
    thinking: {
      zh: '正在分析',
      en: 'Analyzing'
    },
    analyzing: {
      zh: '正在分析',
      en: 'Analyzing'
    },
    processing: {
      zh: '正在分析',
      en: 'Analyzing'
    },
    searching: {
      zh: '正在查找信息',
      en: 'Looking up information'
    },
    web_search: {
      zh: '正在查找信息',
      en: 'Looking up information'
    },
    knowledge_search: {
      zh: '正在查找信息',
      en: 'Looking up information'
    },
    get_event_markets: {
      zh: '正在查找相关市场',
      en: 'Finding related markets'
    },
    get_event_details: {
      zh: '正在查看事件详情',
      en: 'Reviewing event details'
    },
    get_event_price_info: {
      zh: '正在查看价格变化',
      en: 'Checking price moves'
    },
    market_analysis: {
      zh: '正在整理分析结果',
      en: 'Synthesizing findings'
    },
    research_analysis: {
      zh: '正在整理分析结果',
      en: 'Synthesizing findings'
    },
    data_processing: {
      zh: '正在整理分析结果',
      en: 'Synthesizing findings'
    },
    generating_response: {
      zh: '正在整理回答',
      en: 'Preparing response'
    },
    tool_calling: {
      zh: '正在处理中',
      en: 'Working'
    }
  },

  // 工具文案（仅详情层展示）
  toolDisplayNames: {
    // 市场与事件类工具
    GetHotEventsByVolumeOnPolymarket: {
      zh: '查看热门市场',
      en: 'View trending markets'
    },
    SearchEventsOnPolymarket: {
      zh: '查找相关市场',
      en: 'Find related markets'
    },
    SearchMarketOnPolymarket: {
      zh: '查找相关市场',
      en: 'Find related markets'
    },
    GetMarketDetailOnPolymarket: {
      zh: '查看市场信息',
      en: 'Review market details'
    },
    GetEventMarketsOnPolymarket: {
      zh: '查看相关子市场',
      en: 'View related sub-markets'
    },
    GetEventByEventIdOnPolymarket: {
      zh: '查看事件详情',
      en: 'Review event details'
    },
    GetEventByEventSlugOnPolymarket: {
      zh: '按链接查找事件',
      en: 'Find event from link'
    },
    // 交易员与价格类工具
    GetSmartMoneyLeaderboardOnPolymarket: {
      zh: '查看活跃交易员',
      en: 'Review active traders'
    },
    GetTraderPositionsByAddressOnPolymarket: {
      zh: '查看交易员持仓',
      en: 'Review trader positions'
    },
    get_event_price_info: {
      zh: '查看市场价格',
      en: 'Check market price'
    },
    scan_top_market_price_changes_from_db: {
      zh: '查看市场涨跌',
      en: 'Check market movers'
    },
    search_price_change_knowledge: {
      zh: '查找涨跌原因',
      en: 'Look up price drivers'
    },
    refresh_price_change_context_from_db: {
      zh: '更新价格数据',
      en: 'Refresh price data'
    },
    // 系统类工具
    task: {
      zh: '选择合适的分析模式',
      en: 'Select the appropriate analysis mode'
    },
    web_search: {
      zh: '联网核实公开信息',
      en: 'Verify public information online'
    },
    search_help_center: {
      zh: '查找帮助中心信息',
      en: 'Search help-center info'
    }
  },

  // 其他通用文本
  common: {
    defaultState: {
      zh: '正在处理中',
      en: 'Working'
    }
  },

  // 向后兼容：保留原有 agents/tasks 映射（仅用于解析历史数据）
  agents: {
    'market-topic-explainer': { zh: '主题解读', en: 'Topic analysis' },
    'news-analyst': { zh: '新闻解读', en: 'News analysis' },
    'finance-expert': { zh: '市场解读', en: 'Market analysis' },
    'general-researcher': { zh: '综合分析', en: 'General analysis' },
    'beginner-guide': { zh: '新手帮助', en: 'Beginner help' },
    'trading-advisor': { zh: '交易分析', en: 'Trade analysis' },
    'platform-mechanics-expert': { zh: '平台规则', en: 'Platform rules' },
    'event-explainer': { zh: '事件解读', en: 'Event analysis' }
  },
  tasks: {
    thinking: { zh: '正在分析', en: 'Analyzing' },
    analyzing: { zh: '正在分析', en: 'Analyzing' },
    searching: { zh: '正在查找信息', en: 'Looking up information' },
    get_event_markets: { zh: '正在查找相关市场', en: 'Finding related markets' },
    get_event_details: { zh: '正在查看事件详情', en: 'Reviewing event details' },
    web_search: { zh: '正在查找信息', en: 'Looking up information' },
    knowledge_search: { zh: '正在查找信息', en: 'Looking up information' },
    tool_calling: { zh: '正在处理中', en: 'Working' },
    generating_response: { zh: '正在整理回答', en: 'Preparing response' },
    processing: { zh: '正在分析', en: 'Analyzing' },
    market_analysis: { zh: '正在整理分析结果', en: 'Synthesizing findings' },
    data_processing: { zh: '正在整理分析结果', en: 'Synthesizing findings' },
    research_analysis: { zh: '正在整理分析结果', en: 'Synthesizing findings' }
  }
};

/**
 * 获取能力标签（原 agent 名称，现作为辅助标签）
 */
export function getCapabilityTag(agent: string, language: string): string | null {
  const lang = language.startsWith('zh') ? 'zh' : 'en';
  const tag = STEP_TRANSLATIONS.capabilityTags[agent as keyof typeof STEP_TRANSLATIONS.capabilityTags];
  return tag?.[lang] || null;
}

/**
 * 获取主状态文案（用户结果导向）
 */
export function getPrimaryState(task: string, language: string): string {
  const lang = language.startsWith('zh') ? 'zh' : 'en';
  const state = STEP_TRANSLATIONS.primaryStates[task as keyof typeof STEP_TRANSLATIONS.primaryStates];
  return state?.[lang] || STEP_TRANSLATIONS.common.defaultState[lang];
}

/**
 * 获取工具展示文案（仅详情层使用）
 */
export function getToolDisplayName(toolName: string, language: string): string | null {
  const lang = language.startsWith('zh') ? 'zh' : 'en';
  const display = STEP_TRANSLATIONS.toolDisplayNames[toolName as keyof typeof STEP_TRANSLATIONS.toolDisplayNames];
  return display?.[lang] || null;
}

/**
 * 获取本地化的 agent 名称（向后兼容）
 */
export function getLocalizedAgentName(agent: string, language: string): string {
  const lang = language.startsWith('zh') ? 'zh' : 'en';
  return STEP_TRANSLATIONS.agents[agent as keyof typeof STEP_TRANSLATIONS.agents]?.[lang] || agent;
}

/**
 * 获取本地化的 task 名称（向后兼容）
 */
export function getLocalizedTaskName(task: string, language: string): string {
  const lang = language.startsWith('zh') ? 'zh' : 'en';
  return STEP_TRANSLATIONS.tasks[task as keyof typeof STEP_TRANSLATIONS.tasks]?.[lang] || task;
}

/**
 * 获取本地化的步骤标题
 * 新逻辑：只展示主状态，不再把 agent 拼进标题
 */
export function getLocalizedStepTitle(agent: string, task: string, language: string): string {
  return getPrimaryState(task, language);
}

/**
 * 获取完整步骤标题的翻译（用于后端兼容）
 * 新逻辑：返回用户导向的主状态文案
 */
export function getLocalizedFullStepTitle(fullTitle: string, language: string): string {
  const lang = language.startsWith('zh') ? 'zh' : 'en';

  // 新版映射：用户结果导向文案
  const fullTitleMappings: Record<string, Record<string, string>> = {
    // Agent 名称映射到能力标签
    'market-topic-explainer': { zh: '主题解读', en: 'Topic analysis' },
    'news-analyst': { zh: '新闻解读', en: 'News analysis' },
    'finance-expert': { zh: '市场解读', en: 'Market analysis' },
    'general-researcher': { zh: '综合分析', en: 'General analysis' },
    'beginner-guide': { zh: '新手帮助', en: 'Beginner help' },
    'trading-advisor': { zh: '交易分析', en: 'Trade analysis' },
    'platform-mechanics-expert': { zh: '平台规则', en: 'Platform rules' },
    'event-explainer': { zh: '事件解读', en: 'Event analysis' },
    // 旧版 Thinking 标题映射到新版主状态
    'Router Thinking': { zh: '正在分析', en: 'Analyzing' },
    'Market Topic Explainer Thinking': { zh: '正在分析', en: 'Analyzing' },
    'News Analyst Thinking': { zh: '正在分析', en: 'Analyzing' },
    'Finance Expert Thinking': { zh: '正在分析', en: 'Analyzing' },
    'General Researcher Thinking': { zh: '正在分析', en: 'Analyzing' },
    'Beginner Guide Thinking': { zh: '正在分析', en: 'Analyzing' },
    'Trading Advisor Thinking': { zh: '正在分析', en: 'Analyzing' },
    'Platform Mechanics Expert Thinking': { zh: '正在分析', en: 'Analyzing' },
    'Event Explainer Thinking': { zh: '正在分析', en: 'Analyzing' },
    // Task 状态映射
    'Web Search': { zh: '正在查找信息', en: 'Looking up information' },
    'Knowledge Search': { zh: '正在查找信息', en: 'Looking up information' },
    'Tool Calling': { zh: '正在处理中', en: 'Working' },
    'Generating Response': { zh: '正在整理回答', en: 'Preparing response' },
    'Processing': { zh: '正在分析', en: 'Analyzing' },
    'Thinking': { zh: '正在分析', en: 'Analyzing' },
    'Market Analysis': { zh: '正在整理分析结果', en: 'Synthesizing findings' },
    'Data Processing': { zh: '正在整理分析结果', en: 'Synthesizing findings' },
    'Research Analysis': { zh: '正在整理分析结果', en: 'Synthesizing findings' },
  };

  return fullTitleMappings[fullTitle]?.[lang] || fullTitle;
}